import React, { ReactNode, useContext } from "react";
import { Navigate } from "react-router-dom";
import { getTokenExpiration } from "Common/Components/getRoleId";

interface AuthProtectedProps {
  children: ReactNode;
}

const AuthProtected: React.FC<AuthProtectedProps> = ({ children }) => {
  const tokenExpiration = getTokenExpiration(localStorage.getItem("app_atkey"));
  const accesstoken = localStorage.getItem("app_atkey");
  const refreshtoken = localStorage.getItem("app_rtkey");

  if (
    !accesstoken ||
    !refreshtoken ||
    (tokenExpiration && tokenExpiration.getTime() < Date.now())
  ) {
    return <Navigate to="/login" />;
  }
  return <>{children}</>;
};
export default AuthProtected;
